import './TimeConstraintSelection.css';
import React from "react";

function TimeConstraintSelection(props) {

    // function changeTimeConstraintType(checkedType) {
    //     if (checkedType === props.timeConstraintType) {
    //       props.setTimeConstraintType(null)
    //     } else {
    //         props.setTimeConstraintType(checkedType)
    //     }
    // }

    const handleTimeConstraintChange= (event) => {
        props.setTimeConstraintTime(event.target.value);
    };

    return (
                <div className={props.shrunk? "taskTimeConstraintRowShrunk" : "taskTimeConstraintRow"}>
                    {/* <div className={props.shrunk ? "shrunkRow": "normalRow"}>
                        <div onClick={() => changeTimeConstraintType("event")} className={props.timeConstraintType === "event" ? "checkboxTimeConstraint activeCheckboxTimeConstraint" : "checkboxTimeConstraint"}></div>
                        <p className="checkboxTimeConstraintText"> event </p> 
                    </div> */}
                    {/* <div className={props.shrunk ? "shrunkRow": "normalRow"}>
                        <div onClick={() => changeTimeConstraintType("deadline")} className={props.timeConstraintType === "deadline" ? "checkboxTimeConstraint activeCheckboxTimeConstraint" : "checkboxTimeConstraint"}></div>
                        <p className="checkboxTimeConstraintText"> deadline </p> 
                    </div> */}
                  <input
                    className={props.shrunk ? "timeConstraintInput timeConstraintInputShrunk" : "timeConstraintInput"}
                    type="number"
                    step="1"
                    min="5"
                    max="180"
                    id="timeConstraintTime"
                    value={props.timeConstraintTime}
                    onChange={handleTimeConstraintChange}
                    name="timeConstraintTime"
                />
                </div>
    )
}

export default TimeConstraintSelection;